export default __webpack_public_path__ + "bc98f2725c5cd6cb4fc546a442908c7d.png";